import { Component, OnInit, Input, SimpleChanges, OnChanges, EventEmitter, Output, ViewChild, Inject, OnDestroy, forwardRef } from '@angular/core';
import { FormGroup, FormControl, Validators} from '@angular/forms';

import { DatexFormControl } from './models/datex-form-control';
import { 
  TextBoxModel, 
  NumberBoxModel, 
  SelectBoxModel, 
  ESelectBoxType,
  DateBoxModel, 
  CheckBoxModel, 
  TextModel, 
  LabelModel, 
  ButtonModel,
  SplitButtonModel,
  SeparatorModel,
  ImageModel,
  DrawModel,
  CodeBoxModel,
  ButtonStyles 
} from './models/control';
import { GridHeaderModel, GridCellModel, GridRowModel, CellStyles, GridContainerStyle, HeaderStyles } from './models/grid'
import { FieldModel } from './models/field'
import { ToolModel } from './models/tool';
import { Styles, ControlContainerStyles } from './models/style';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { isEqual, isNil, set } from 'lodash-es';
import { GridComponent, ELoadingStatus } from './components/grid.component';
import { WorkBook, read as readExcelFile, writeFile as writeExcelFile, utils as excelUtils } from 'xlsx';

import { SharedModule } from './shared.module';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';
import { FootPrintPortalManager_ShellService, EModalSize, EToasterType, EToasterPosition } from './FootPrintPortalManager.shell.service';
import { FootPrintPortalManager_OperationService } from './FootPrintPortalManager.operation.service';
import { FootPrintPortalManager_DatasourceService } from './FootPrintPortalManager.datasource.index';
import { FootPrintPortalManager_FlowService } from './FootPrintPortalManager.flow.index';
import { FootPrintPortalManager_ReportService } from './FootPrintPortalManager.report.index';
import { FootPrintPortalManager_LocalizationService } from './FootPrintPortalManager.localization.service';
import { Language } from './localization.service';
import { $types } from './FootPrintPortalManager.types'


interface IFootPrintPortalManager_inventory_transactions_gridComponentEntity {
Id?: number, ActualPackagedAmount?: number, CompletedDateTime?: string, CreatedSysDateTime?: string, ExpectedPackagedAmount?: number, LotId?: number, ModifiedSysUser?: string, Project?: { LookupCode?: string }, Material?: { Description?: string, LookupCode?: string, Project?: { LookupCode?: string, Owner?: { LookupCode?: string } } }, Order?: { Id?: number, LookupCode?: string, OrderClassId?: number, OwnerReference?: string, VendorReference?: string, Account?: { Id?: number, AccountsContactsLookup?: { ContactId?: number, Contact?: { FirstName?: string, LastName?: string, PrimaryEmail?: string, PrimaryTelephone?: string, Address?: { AttentionOf?: string, City?: string, Country?: string, Line1?: string, Line2?: string, PostalCode?: string, State?: string } } }[] }, Addresses?: { AttentionOf?: string, City?: string, Country?: string, FirstName?: string, LastName?: string, Line1?: string, Line2?: string, PostalCode?: string, PrimaryEmail?: string, PrimaryTelephone?: string, State?: string }[] }, Warehouse?: { Name?: string }, Lot?: { LookupCode?: string, ReceiveDate?: string, VendorLot?: { LookupCode?: string, Vat?: string } }, ActualSourceLocation?: { Name?: string }, ActualTargetLocation?: { Name?: string }, OperationCode?: { Name?: string }, ExpectedSourceLicensePlate?: { Id?: number, LookupCode?: string, Location?: { Name?: string } }}

interface IFootPrintPortalManager_inventory_transactions_gridComponentInParams {
  ownerId: number, projectId?: number, warehouseId?: number[], createdFrom?: string, createdTo?: string, materialIds?: number[], operationCodeIds?: number[]}


class FootPrintPortalManager_inventory_transactions_gridComponentRowModel extends GridRowModel {
  grid: FootPrintPortalManager_inventory_transactions_gridComponent;
  entity: IFootPrintPortalManager_inventory_transactions_gridComponentEntity;



 // temporarily put required on all edit controls
  override formGroup = new FormGroup({
  });

  override cells = {
    order_lookupcode: new GridCellModel(
      new CellStyles(['grid-table-cell-link'], null),
      new TextModel(null, null )
,
null
      ),
    material_lookupcode: new GridCellModel(
      new CellStyles(null, null),
      new TextModel(null, null )
,
null
      ),
    operationcode: new GridCellModel(
      new CellStyles(null, null),
      new TextModel(null, null )
,
null
      ),
    material_description: new GridCellModel(
      new CellStyles(null, null),
      new TextModel(null, null )
,
null
      ),
    created_date: new GridCellModel(
      new CellStyles(null, null),
      new TextModel(null, null )
,
null
      ),
    completed_date: new GridCellModel(
      new CellStyles(null, null),
      new TextModel(null, null )
,
null
      ),
    project_lookupcode: new GridCellModel(
      new CellStyles(null, null),
      new TextModel(null, null )
,
null
      ),
    owner_reference: new GridCellModel(
      new CellStyles(null, null),
      new TextModel(null, null )
,
null
      ),
    vendor_reference: new GridCellModel(
      new CellStyles(null, null),
      new TextModel(null, null )
,
null
      ),
    actual_packaged_amount: new GridCellModel(
      new CellStyles(null, null),
      new TextModel(null, null )
,
null
      ),
    lot: new GridCellModel(
      new CellStyles(null, null),
      new TextModel(null, null )
,
null
      ),
    vendorlot: new GridCellModel(
      new CellStyles(null, null),
      new TextModel(null, null )
,
null
      ),
    received_date: new GridCellModel(
      new CellStyles(null, null),
      new TextModel(null, null )
,
null
      ),
    actual_source_location: new GridCellModel(
      new CellStyles(null, null),
      new TextModel(null, null )
,
null
      ),
    actual_target_location: new GridCellModel(
      new CellStyles(null, null),
      new TextModel(null, null )
,
null
      ),
    warehouse: new GridCellModel(
      new CellStyles(null, null),
      new TextModel(null, null )
,
null
      ),
    destination_name: new GridCellModel(
      new CellStyles(null, null),
      new TextModel(null, null )
,
null
      ),
    destination_line1: new GridCellModel(
      new CellStyles(null, null),
      new TextModel(null, null )
,
null
      ),
    destination_line2: new GridCellModel(
      new CellStyles(null, null),
      new TextModel(null, null )
,
null
      ),
    destination_city: new GridCellModel(
      new CellStyles(null, null),
      new TextModel(null, null )
,
null
      ),
    destination_postal_code: new GridCellModel(
      new CellStyles(null, null),
      new TextModel(null, null )
,
null
      ),
    destination_country: new GridCellModel(
      new CellStyles(null, null),
      new TextModel(null, null )
,
null
      ),
  }



  constructor(
    private utils: UtilsService,
private settings: SettingsValuesService,
private shell: FootPrintPortalManager_ShellService,
private datasources: FootPrintPortalManager_DatasourceService,
private flows: FootPrintPortalManager_FlowService,
private reports: FootPrintPortalManager_ReportService,
private localization: FootPrintPortalManager_LocalizationService,
private operations: FootPrintPortalManager_OperationService,
) {
    super();
    
  }

  async $initializeExisting(grid: FootPrintPortalManager_inventory_transactions_gridComponent, entity: IFootPrintPortalManager_inventory_transactions_gridComponentEntity, propertyChangeCallback: (source: GridRowModel, property: string) => void = null) {
    this.$propertyChangeCallback = propertyChangeCallback;

    this.grid = grid;
    this.entity = entity;

    this.rowId = [this.entity.Id].join('-');

    await this.$dataLoaded();
  }

  async $initializeNew(grid: FootPrintPortalManager_inventory_transactions_gridComponent, entity?: IFootPrintPortalManager_inventory_transactions_gridComponentEntity, propertyChangeCallback: (source: GridRowModel, property: string) => void = null) {
    this.$propertyChangeCallback = propertyChangeCallback;

    this.grid = grid;
    this.isNew = true;

    if (entity) {
      this.entity = entity;
    }
    else {
      this.entity = {};
    }

    this.rowId = [this.entity.Id].join('-');
    this.$dataLoaded();
    // mark the whole form as dirty, since this is a new row 
    // and even if it is valid, it should have a changed state
    this.formGroup.markAsDirty();
  }

  private $unsubscribe$ = new Subject();
  override destroy(): void {
    this.$unsubscribe$.next(null);
    this.$unsubscribe$.complete();
  }

  $init() {
  }

  async $dataLoad() {
    const $row = this;
    const $grid = this.grid;
    const $utils = this.utils;
    const $resultKey = this.entity.Id;
    const inParams = {
      $keys:[$resultKey],
      ownerId:  $grid.inParams.ownerId ,
      projectId:  $grid.inParams.projectId ,
      warehouseId:  $grid.inParams.warehouseId ,
      createdFrom:  $grid.inParams.createdFrom ,
      createdTo:  $grid.inParams.createdTo ,
      fullTextSearch:  $grid.fullTextSearch ,
      materialIds:  $grid.inParams.materialIds ,
      operationCodeIds:  $grid.inParams.operationCodeIds ,
      take:  null ,
      skip:  null ,
    };
    const data = await this.datasources.FootPrintPortalManager.ds_inventory_transactions_grid.getByKeys(inParams);
    this.entity = data.result[0];
    await this.$dataLoaded();
  }

  async $dataLoaded() {
    const $row = this;
    const $grid = this.grid;
    const $utils = this.utils;
    (this.cells.order_lookupcode.displayControl as TextModel).text = $row.entity.Order?.LookupCode;
    (this.cells.material_lookupcode.displayControl as TextModel).text = $row.entity.Material?.LookupCode;
    (this.cells.operationcode.displayControl as TextModel).text = $row.entity.OperationCode?.Name;
    (this.cells.material_description.displayControl as TextModel).text = $row.entity.Material?.Description;
    (this.cells.project_lookupcode.displayControl as TextModel).text = $row.entity.Material?.Project?.LookupCode;
    (this.cells.owner_reference.displayControl as TextModel).text = $row.entity.Order?.OwnerReference;
    (this.cells.vendor_reference.displayControl as TextModel).text = $row.entity.Order?.VendorReference;
    (this.cells.lot.displayControl as TextModel).text = $row.entity.Lot?.LookupCode;
    (this.cells.vendorlot.displayControl as TextModel).text = $row.entity.Lot?.VendorLot?.LookupCode;
    (this.cells.actual_source_location.displayControl as TextModel).text = $row.entity.ActualSourceLocation?.Name ?? $row.entity.ExpectedSourceLicensePlate?.Location?.Name;
    (this.cells.actual_target_location.displayControl as TextModel).text = $row.entity.ActualTargetLocation?.Name;
    (this.cells.warehouse.displayControl as TextModel).text = $row.entity.Warehouse?.Name;

    await this.on_row_data_loaded();
  }

  override async refresh() {
    if (this.grid.$hasMissingRequiredInParams) {
      return Promise.resolve(null);
    }
    await this.$dataLoad();
    // grid refresh skipSelf=true, skipParent=false, skipChildren=false  
    this.grid.$refreshEvent.emit();
  }

  override async save() {
    if (this.isNew) {
    } else {
    } 
  }

  override $cellClicked(cellId: string) {
    super.$cellClicked(cellId);
    switch(cellId) {
      case 'order_lookupcode' : {
        this.on_order_clicked();
        break;
      }
    }
  }

  //#region private flows
  on_row_data_loaded(event = null) {
    return this.on_row_data_loadedInternal(
      this,
  this.grid, this.shell,
      this.datasources,
      this.flows,
      this.reports,
      this.settings,
      this.operations,
      this.utils,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_row_data_loadedInternal(
    $row: FootPrintPortalManager_inventory_transactions_gridComponentRowModel,
  $grid: FootPrintPortalManager_inventory_transactions_gridComponent, 
    $shell: FootPrintPortalManager_ShellService,
    $datasources: FootPrintPortalManager_DatasourceService,
    $flows: FootPrintPortalManager_FlowService,
    $reports: FootPrintPortalManager_ReportService,
    $settings: SettingsValuesService,
    $operations: FootPrintPortalManager_OperationService,
    $utils: UtilsService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: FootPrintPortalManager_LocalizationService,
    $event: any
  ) {
  
  // Apply date format
  if ($utils.isDefined($row.entity.CompletedDateTime) && $utils.isDefined($settings.FootPrintPortalManager.DateFormat)) {
      var dateFormat = $settings.FootPrintPortalManager.DateFormat;
      var completedDate = $utils.date.format($row.entity.CompletedDateTime, dateFormat);
      $row.cells.completed_date.displayControl.text = completedDate;
  }
  
  if ($utils.isDefined($row.entity.CreatedSysDateTime) && $utils.isDefined($settings.FootPrintPortalManager.DateFormat)) {
      var createdDate = $utils.date.format($row.entity.CreatedSysDateTime, dateFormat);
      $row.cells.created_date.displayControl.text = createdDate;
  }
  
  if ($utils.isDefined($row.entity.Lot?.ReceiveDate) && $utils.isDefined($settings.FootPrintPortalManager.DateFormat)) {
      var dateFormat = $settings.FootPrintPortalManager.DateFormat;
      var receivedDate = $utils.date.format($row.entity.Lot.ReceiveDate, dateFormat);
      $row.cells.received_date.displayControl.text = receivedDate;
  }
  
  // Set Qty
  if ($utils.isDefined($row.entity.CompletedDateTime)) {
      $row.cells.actual_packaged_amount.displayControl.text = $row.entity.ActualPackagedAmount?.toString();
  }
  else {
      $row.cells.actual_packaged_amount.displayControl.text = $row.entity.ExpectedPackagedAmount?.toString();
  }
  
  
  if ($utils.isDefined($row.entity.Order?.Addresses[0]?.FirstName)) {
      $row.cells.destination_name.displayControl.text = $row.entity.Order?.Addresses[0]?.FirstName + ' ' + $row.entity.Order?.Addresses[0]?.LastName;
      $row.cells.destination_line1.displayControl.text = $row.entity.Order?.Addresses[0]?.Line1;
      $row.cells.destination_line2.displayControl.text = $row.entity.Order?.Addresses[0]?.Line2;
      $row.cells.destination_city.displayControl.text = $row.entity.Order?.Addresses[0]?.City;
      $row.cells.destination_postal_code.displayControl.text = $row.entity.Order?.Addresses[0]?.PostalCode;
      $row.cells.destination_country.displayControl.text = $row.entity.Order?.Addresses[0]?.Country;
  }
  else {
      if (!$row.entity.Order?.Account?.AccountsContactsLookup[0]?.Contact?.FirstName.includes('ord-') && !$row.entity.Order?.Account?.AccountsContactsLookup[0]?.Contact?.Address?.Line1.includes('ord-')) {
          $row.cells.destination_name.displayControl.text = $row.entity.Order?.Account?.AccountsContactsLookup[0]?.Contact?.FirstName + ' ' + $row.entity.Order?.Account?.AccountsContactsLookup[0]?.Contact?.LastName;
          $row.cells.destination_line1.displayControl.text = $row.entity.Order?.Account?.AccountsContactsLookup[0]?.Contact?.Address?.Line1;
          $row.cells.destination_line2.displayControl.text = $row.entity.Order?.Account?.AccountsContactsLookup[0]?.Contact?.Address?.Line2;
          $row.cells.destination_city.displayControl.text = $row.entity.Order?.Account?.AccountsContactsLookup[0]?.Contact?.Address?.City;
          $row.cells.destination_postal_code.displayControl.text = $row.entity.Order?.Account?.AccountsContactsLookup[0]?.Contact?.Address?.PostalCode;
          $row.cells.destination_country.displayControl.text = $row.entity.Order?.Account?.AccountsContactsLookup[0]?.Contact?.Address?.Country;
      }
  }
  
  
  
  }
  on_order_clicked(event = null) {
    return this.on_order_clickedInternal(
      this,
  this.grid, this.shell,
      this.datasources,
      this.flows,
      this.reports,
      this.settings,
      this.operations,
      this.utils,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_order_clickedInternal(
    $row: FootPrintPortalManager_inventory_transactions_gridComponentRowModel,
  $grid: FootPrintPortalManager_inventory_transactions_gridComponent, 
    $shell: FootPrintPortalManager_ShellService,
    $datasources: FootPrintPortalManager_DatasourceService,
    $flows: FootPrintPortalManager_FlowService,
    $reports: FootPrintPortalManager_ReportService,
    $settings: SettingsValuesService,
    $operations: FootPrintPortalManager_OperationService,
    $utils: UtilsService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: FootPrintPortalManager_LocalizationService,
    $event: any
  ) {
  
  var orderId = $row.entity.Order.Id;
  
  // Check order class type
  const order = (await $datasources.PurchaseOrders.ds_get_order_by_orderId.get({ orderId: orderId })).result;
  if ($utils.isDefined(order)) {
      const orderClassTypeId = order.OrderClass.OrderClassTypeId;
      if (orderClassTypeId == 1) {
          $shell.FootPrintPortalManager.openreceiving_order_editor({ orderId: orderId });
      }
      else if (orderClassTypeId == 12) {
          $shell.FootPrintPortalManager.openasn_order_editor({ orderId: orderId });
      }
      else if (orderClassTypeId == 5) {
          $shell.FootPrintPortalManager.openshipping_order_editor({ orderId: orderId });
      }
      else {
          throw new Error('Order class for selected order is not of type purchase order, asn order or sales order.')
      }
  
  }
  else {
  
      throw new Error('Order class on selected order could not be determined.')
  }
  }
  //#endregion private flows

}


@Component({
  standalone: true,
  imports: [
    SharedModule,
  ],
  selector: 'FootPrintPortalManager-inventory_transactions_grid',
  templateUrl: './FootPrintPortalManager.inventory_transactions_grid.component.html'
})
export class FootPrintPortalManager_inventory_transactions_gridComponent implements OnInit, OnChanges, OnDestroy {
  //#region Outputs
  @Output()
  $finish = new EventEmitter();
  @Output()
  $refreshEvent = new EventEmitter();
  //#endregion Outputs

  entities: IFootPrintPortalManager_inventory_transactions_gridComponentEntity[];

  pageSize = 500;
  pageSkip = 0;
  totalCount = 0;
  loadingStatus = ELoadingStatus.Loading;


// to stop add from flow
// canAdd = false; //hide add button, check on exitFromLastCell 
// bottomToolbar.addLine.hidden = true; //hide add button, no check on exitFromLastCell 
// bottomToolbar.addLine.control.readOnly = true; //disable add button, check on exitFromLastCell 
 
  
  containerStyles: GridContainerStyle = new GridContainerStyle('cellsWidth', ['compact','fit-content-table']);

  fullTextSearch: string;

  inParams: IFootPrintPortalManager_inventory_transactions_gridComponentInParams = { ownerId: null, projectId: null, warehouseId: [], createdFrom: null, createdTo: null, materialIds: [], operationCodeIds: [] };


  //#region Variables
  //#endregion
  //#region Events
  
  //#endregion

  headers = {
     order_lookupcode: new GridHeaderModel(new HeaderStyles(null, null), 'Order', false, false, null),       material_lookupcode: new GridHeaderModel(new HeaderStyles(null, null), 'Material', false, false, null),       operationcode: new GridHeaderModel(new HeaderStyles(null, null), 'Operation code', false, false, null),       material_description: new GridHeaderModel(new HeaderStyles(null, null), 'Description', false, false, null),       created_date: new GridHeaderModel(new HeaderStyles(null, null), 'Created', false, false, null),       completed_date: new GridHeaderModel(new HeaderStyles(null, null), 'Completed', false, false, null),       project_lookupcode: new GridHeaderModel(new HeaderStyles(null, null), 'Project', false, false, null),       owner_reference: new GridHeaderModel(new HeaderStyles(null, null), 'Owner reference', false, false, null),       vendor_reference: new GridHeaderModel(new HeaderStyles(null, null), 'PO', false, false, null),       actual_packaged_amount: new GridHeaderModel(new HeaderStyles(null, null), 'Qty', false, false, null),       lot: new GridHeaderModel(new HeaderStyles(null, null), 'Lot', false, false, null),       vendorlot: new GridHeaderModel(new HeaderStyles(null, null), 'Vendor lot', false, false, null),       received_date: new GridHeaderModel(new HeaderStyles(null, null), 'Recv Date', false, false, null),       actual_source_location: new GridHeaderModel(new HeaderStyles(null, null), 'Source', false, false, null),       actual_target_location: new GridHeaderModel(new HeaderStyles(null, null), 'Target', false, false, null),       warehouse: new GridHeaderModel(new HeaderStyles(null, null), 'Warehouse', false, false, null),       destination_name: new GridHeaderModel(new HeaderStyles(null, null), 'Destination name', false, false, null),       destination_line1: new GridHeaderModel(new HeaderStyles(null, null), 'Destination line 1', false, false, null),       destination_line2: new GridHeaderModel(new HeaderStyles(null, null), 'Destination line 2', false, false, null),       destination_city: new GridHeaderModel(new HeaderStyles(null, null), 'Destination city', false, false, null),       destination_postal_code: new GridHeaderModel(new HeaderStyles(null, null), 'Destination postal code', false, false, null),       destination_country: new GridHeaderModel(new HeaderStyles(null, null), 'Destination country', false, false, null),  
  };

  //#region title
  // Make it async so that it won't cause expressionChangedAfterItHasBeenCheckedError
  // The title is often meant to be shown from the parent (shell breadcrumb for example)
  // and often it will cause an expressionChangedAfterItHasBeenCheckedError because 
  // the parent has already been checked and the child now change something on the parent 
  // in dev, CD is run twice
  $titleChange = new EventEmitter<string>(true);
  private $_title: string;
  get title(): string {
    return this.$_title;
  }
  set title(t: string) {
    this.$_title = t;
    this.$titleChange.emit(this.$_title);
  }
  //#endregion title
  rows: FootPrintPortalManager_inventory_transactions_gridComponentRowModel[] = [];
  @ViewChild('$gridComponent', { read:  GridComponent}) $gridComponent: GridComponent;

  @Input('ownerId') set $inParams_ownerId(value: any) {
    this.inParams['ownerId'] = value;
  }
  get $inParams_ownerId(): any {
    return this.inParams['ownerId'] ;
  }
  @Input('projectId') set $inParams_projectId(value: any) {
    this.inParams['projectId'] = value;
  }
  get $inParams_projectId(): any {
    return this.inParams['projectId'] ;
  }
  @Input('warehouseId') set $inParams_warehouseId(value: any) {
    this.inParams['warehouseId'] = value;
  }
  get $inParams_warehouseId(): any {
    return this.inParams['warehouseId'] ;
  }
  @Input('createdFrom') set $inParams_createdFrom(value: any) {
    this.inParams['createdFrom'] = value;
  }
  get $inParams_createdFrom(): any {
    return this.inParams['createdFrom'] ;
  }
  @Input('createdTo') set $inParams_createdTo(value: any) {
    this.inParams['createdTo'] = value;
  }
  get $inParams_createdTo(): any {
    return this.inParams['createdTo'] ;
  }
  @Input('materialIds') set $inParams_materialIds(value: any) {
    this.inParams['materialIds'] = value;
  }
  get $inParams_materialIds(): any {
    return this.inParams['materialIds'] ;
  }
  @Input('operationCodeIds') set $inParams_operationCodeIds(value: any) {
    this.inParams['operationCodeIds'] = value;
  }
  get $inParams_operationCodeIds(): any {
    return this.inParams['operationCodeIds'] ;
  }

  topToolbar = {
  };

  bottomToolbar = {
  };



  constructor(
    private utils: UtilsService,
    private settings: SettingsValuesService,
    private shell: FootPrintPortalManager_ShellService,
    private datasources: FootPrintPortalManager_DatasourceService,
    private flows: FootPrintPortalManager_FlowService,
    private reports: FootPrintPortalManager_ReportService,
    private localization: FootPrintPortalManager_LocalizationService,
    private operations: FootPrintPortalManager_OperationService,
    ) {
    this.title = 'Transactions';
    this.$subscribeFormControlValueChanges();
  }

  ngOnInit(): void {
    this.$checkRequiredInParams();
    if(!this.$hasMissingRequiredInParams) {
      this.$init();
    }
  }
  
  private $isFirstNgOnChanges = true;
  ngOnChanges(changes: SimpleChanges): void {
    if (this.$isFirstNgOnChanges) {
      this.$isFirstNgOnChanges = false;
    } else {
      this.$checkRequiredInParams();
      if(!this.$hasMissingRequiredInParams) {
        this.$init();
      }
    }
  }

  $missingRequiredInParams = [];
  get $hasMissingRequiredInParams(): boolean {
    return !!this.$missingRequiredInParams.length;
  }
  
  $checkRequiredInParams() {
    this.$missingRequiredInParams = [];
      if(isNil(this.inParams.ownerId)) {
        this.$missingRequiredInParams.push('ownerId');
      }
  }

  initialized = false;

  private $unsubscribe$ = new Subject();
  ngOnDestroy(): void {
    this.$unsubscribe$.next(null);
    this.$unsubscribe$.complete();
    if(this.rows && this.rows.length) {
      this.rows.forEach(r => r.destroy());
    }
  }

  async $init() {
    const $grid = this;
    const $utils = this.utils;


    this.initialized = true;

    this.pageSkip = 0;
    this.refresh(true, true, null);
  }

  private $subscribeFormControlValueChanges() {

  }

  reload() {
    this.pageSkip = 0;
    this.refresh();
  }

  refresh(
    skipParent = false,
    skipChildren = false,
    childToSkip: string = null) {
    if (this.$hasMissingRequiredInParams) {
      return Promise.resolve(null);
    }
    // up
    if (skipParent === false) {
      this.$refreshEvent.emit();
    }

    // self
    const result = this.$dataLoad();

    // children
    if (skipChildren === false) {
    }

    return result;
  }

  $rowPropertyChangeCallback (source: GridRowModel, property: string): void {
    if (property === 'selected') {
      this.$gridComponent.updateAllSelected();
    }
  }

  async $dataLoad() {
    this.loadingStatus = ELoadingStatus.Loading;
    const $grid = this;
    const $utils = this.utils;
    const inParams = {
      $top: this.pageSize,
      $skip: this.pageSkip,
      ownerId:  $grid.inParams.ownerId ,
      projectId:  $grid.inParams.projectId ,
      warehouseId:  $grid.inParams.warehouseId ,
      createdFrom:  $grid.inParams.createdFrom ,
      createdTo:  $grid.inParams.createdTo ,
      fullTextSearch:  $grid.fullTextSearch ,
      materialIds:  $grid.inParams.materialIds ,
      operationCodeIds:  $grid.inParams.operationCodeIds ,
      take:  null ,
      skip:  null ,
    };
    try {
    const data = await this.datasources.FootPrintPortalManager.ds_inventory_transactions_grid.getList(inParams);
      this.entities = data.result;
      this.totalCount = data.totalCount;
      await this.$dataLoaded();
      if (this.totalCount === 0) {
        this.loadingStatus = ELoadingStatus.NoResults;
      } else {
        this.loadingStatus = ELoadingStatus.Loaded;
      }
    } catch(error) {
      console.error("Error loading data:", error);
      this.loadingStatus = ELoadingStatus.Error;
    }
  }

  async $dataLoaded() {
    const $grid = this;
    const $utils = this.utils;
    
    if(this.rows && this.rows.length) {
      this.rows.forEach(r => r.destroy());
    }
    this.rows = [];

    if(this.entities) {
      let rowLoadPromises = [];
      for (let entity of this.entities) {
        const row = new FootPrintPortalManager_inventory_transactions_gridComponentRowModel(
          this.utils,
          this.settings,
          this.shell, 
          this.datasources,
          this.flows,
          this.reports,
          this.localization,
          this.operations);
        rowLoadPromises.push( row.$initializeExisting(this, entity, this.$rowPropertyChangeCallback.bind(this)));
        this.rows.push(row);
      }
      await Promise.all(rowLoadPromises);
    }

  }


  
  openImageViewer(imageSource: string) {
    this.shell.openImageViewerDialog(imageSource);
  }

  //#region private flows
  on_init(event = null) {
    return this.on_initInternal(
      this,
  this.shell,
      this.datasources,
      this.flows,
      this.reports,
      this.settings,
      this.operations,
      this.utils,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_initInternal(
    $grid: FootPrintPortalManager_inventory_transactions_gridComponent,
  
    $shell: FootPrintPortalManager_ShellService,
    $datasources: FootPrintPortalManager_DatasourceService,
    $flows: FootPrintPortalManager_FlowService,
    $reports: FootPrintPortalManager_ReportService,
    $settings: SettingsValuesService,
    $operations: FootPrintPortalManager_OperationService,
    $utils: UtilsService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: FootPrintPortalManager_LocalizationService,
    $event: any
  ) {
  // Initialize date format
  var dateFormat = $settings.FootPrintPortalManager.DateFormat;
  
  }
  on_export_flow(event = null) {
    return this.on_export_flowInternal(
      this,
  this.shell,
      this.datasources,
      this.flows,
      this.reports,
      this.settings,
      this.operations,
      this.utils,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_export_flowInternal(
    $grid: FootPrintPortalManager_inventory_transactions_gridComponent,
  
    $shell: FootPrintPortalManager_ShellService,
    $datasources: FootPrintPortalManager_DatasourceService,
    $flows: FootPrintPortalManager_FlowService,
    $reports: FootPrintPortalManager_ReportService,
    $settings: SettingsValuesService,
    $operations: FootPrintPortalManager_OperationService,
    $utils: UtilsService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: FootPrintPortalManager_LocalizationService,
    $event: any
  ) {
  
  
  
  // Initialize
  var wb = $event;
  
  var transactions = [];
  
  let dateFormat = $settings.FootPrintPortalManager.DateFormat ?? "MM/dd/yyyy";
  const batchSize = 250;
  
  var allData: any[] = [];
  // Get all data from datasource
  
  do {
  
      var response = await $datasources.FootPrintPortalManager.ds_inventory_transactions_grid.get({
          ownerId: $grid.inParams.ownerId,
          projectId: $grid.inParams.projectId,
          warehouseId: $grid.inParams.warehouseId,
          createdFrom: $grid.inParams.createdFrom,
          createdTo: $grid.inParams.createdTo,
          fullTextSearch: $grid.fullTextSearch,
          materialIds: $grid.inParams.materialIds,
          operationCodeIds: $grid.inParams.operationCodeIds,
          take: batchSize,
          skip: allData.length
      });
  
      allData = allData.concat(response.result);
  
  } while (allData.length < response.totalCount)
  
  
  
  // Compile all data into JSON
  for (let record of allData) {
      // Set Address
      if ($utils.isDefined(record.Order?.Addresses[0]?.FirstName)) {
          var addressName = record.Order?.Addresses[0]?.FirstName + ' ' + record.Order?.Addresses[0]?.LastName;
          var addressLine1 = record.Order?.Addresses[0]?.Line1;
          var addressLine2 = record.Order?.Addresses[0]?.Line2;
          var addressCity = record.Order?.Addresses[0]?.City;
          var addressPostalCode = record.Order?.Addresses[0]?.PostalCode;
          var addressCountry = record.Order?.Addresses[0]?.Country;
  
  
      }
      else {
          var addressName = record.Order?.Account?.AccountsContactsLookup[0]?.Contact?.FirstName + ' ' + record.Order?.Account?.AccountsContactsLookup[0]?.Contact?.LastName;
          var addressLine1 = record.Order?.Account?.AccountsContactsLookup[0]?.Contact?.Address?.Line1;
          var addressLine2 = record.Order?.Account?.AccountsContactsLookup[0]?.Contact?.Address?.Line2;
          var addressCity = record.Order?.Account?.AccountsContactsLookup[0]?.Contact?.Address?.City;
          var addressPostalCode = record.Order?.Account?.AccountsContactsLookup[0]?.Contact?.Address?.PostalCode;
          var addressCountry = record.Order?.Account?.AccountsContactsLookup[0]?.Contact?.Address?.Country;
  
      }
      if ($utils.isDefined(addressName) && addressName.includes('ord-')) {
          addressName = '';
      }
      if ($utils.isDefined(addressLine1) && addressLine1.includes('ord-')) {
          addressLine1 = '';
      }
      var quantity;
      if ($utils.isDefined(record.CompletedDateTime)) {
          quantity = record.ActualPackagedAmount;
      } else {
          quantity = record.ExpectedPackagedAmount;
      }
  
      transactions.push({
          
          "Order": record.Order?.LookupCode,
          "Material": record.Material?.LookupCode,
          "Description": record.Material?.Description,
          "Operation Code": record.OperationCode?.Name,
          "Created": $utils.date.format(record.CreatedSysDateTime, dateFormat),
          "Completed": $utils.date.format(record.CompletedDateTime, dateFormat),
          "Project": record.Material?.Project?.LookupCode, // Just in case project on pick task does not match project of material (custom order substitution logic)
          "Employee": record.ModifiedSysUser,
          "Reference": record.Order?.OwnerReference,
          "PO": record.Order?.VendorReference,
          "Qty": quantity,
          "Lot": record.Lot?.LookupCode,
          "Recv Date": $utils.date.format(record.Lot?.ReceiveDate, dateFormat),
          "Vendor lot": record.Lot?.VendorLot?.LookupCode,
          "Originating Order": record.inbound_order?.order?.LookupCode ?? record.Lot?.LookupCode,
          "Source": record.ActualSourceLocation?.Name ?? record.ExpectedSourceLicensePlate?.Location?.Name,
          "Target": record.ActualTargetLocation?.Name,
          "Warehouse": record.Warehouse?.Name,
          "Destination Name": addressName,
          "Destination Line 1": addressLine1,
          "Destination Line 2": addressLine2,
          "Destination City": addressCity,
          "Destination Postal Code": addressPostalCode,
          "Destination Country": addressCountry
      });
  }
  
  
  
  
  
  var ws = $utils.excel.json_to_sheet(transactions);
  
  $utils.excel.book_append_sheet(wb, ws, "Export");
  
  
  
  
  
  
  
  
  
  
  
  }
  //#endregion private flows


  async $exportExcel() {
    const wb: WorkBook = excelUtils.book_new();

    await this.on_export_flow(wb);

    writeExcelFile(wb, 'FootPrintPortalManager_inventory_transactions_gridComponent_export.xlsx');
  }
 
  close() {
    this.$finish.emit();
  }
}
